import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import jwt_decode from "jwt-decode";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from "../apiConfig";

const List = () => {
  const token        = localStorage.getItem("jwtToken");
  const decodedToken = token ? jwt_decode(token) : null;
  const user_id      = decodedToken ? decodedToken.user_id : null;

  const [data,      setData]      = useState([]);
  const [summary,   setSummary]   = useState(null);
  const [limit]                   = useState(50);
  const [pageCount, setPageCount] = useState(1);
  const [search,    setSearch]    = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate,   setEndDate]   = useState("");
  const currentPage = useRef(1);

  // fetch whenever filters change
  useEffect(() => {
    currentPage.current = 1;
    getPaginatedUsers();
  }, [startDate, endDate]);

  function getPaginatedUsers() {
    const params = new URLSearchParams({
      page: currentPage.current,
      limit,
      user_id,
      ...(search    && { search }),
      ...(startDate && { startDate }),
      ...(endDate   && { endDate }),
    });

    fetch(`${apiConfig.baseURL}/api/agent/affiliate_withdraw_list?${params}`)
      .then((res) => res.json())
      .then((res) => {
        setPageCount(res.pageCount);
        setData(res.result || []);
        setSummary(res.summary);
      })
      .catch(console.error);
  }

  function handlePageClick(e) {
    currentPage.current = e.selected + 1;
    getPaginatedUsers();
  }

  function handleSearch(e) {
    e.preventDefault();
    currentPage.current = 1;
    getPaginatedUsers();
  }

  function handleReset() {
    setSearch("");
    setStartDate("");
    setEndDate("");
    currentPage.current = 1;
    // useEffect on startDate/endDate will re-fetch automatically
  }

  function setThisWeek() {
    const now = new Date();
    const day = now.getDay();
    const monday = new Date(now);
    monday.setDate(now.getDate() - (day === 0 ? 6 : day - 1));
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    const fmt = (d) => d.toISOString().split("T")[0];
    setStartDate(fmt(monday));
    setEndDate(fmt(sunday));
    currentPage.current = 1;
  }

  function setLastWeek() {
    const now = new Date();
    const day = now.getDay();
    const lastMonday = new Date(now);
    lastMonday.setDate(now.getDate() - (day === 0 ? 13 : day + 6));
    const lastSunday = new Date(lastMonday);
    lastSunday.setDate(lastMonday.getDate() + 6);
    const fmt = (d) => d.toISOString().split("T")[0];
    setStartDate(fmt(lastMonday));
    setEndDate(fmt(lastSunday));
    currentPage.current = 1;
  }

  const MyPaginate = styled(ReactPaginate).attrs({ activeClassName: "active" })`
    display: flex;
    justify-content: center;
    list-style: none;
    margin-top: 20px;
    li a {
      padding: 5px 10px;
      border: 1px solid #ddd;
      margin: 0 4px;
      cursor: pointer;
      border-radius: 6px;
    }
    li.active a { background: #28a745; color: white; border: none; }
    li.disabled a { color: #ccc; }
  `;

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const h = d.getHours(), m = d.getMinutes();
    const ampm = h >= 12 ? "PM" : "AM";
    const fh = (h % 12 || 12).toString();
    const fm = m.toString().padStart(2, "0");
    return `${fh}:${fm} ${ampm}  ${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  const statusColor = (s) =>
    s?.toLowerCase() === "paid" ? "green" : s?.toLowerCase() === "pending" ? "orange" : "red";

  return (
    <div id="main-wrapper">
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="card">

            <div className="card-header">
              <h4 className="card-title">Withdraw Report</h4>
            </div>

            <div className="card-body">

              {/* ── Filters ── */}
              <div className="row mb-3 g-2">
                <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search user / txn / number..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSearch(e)}
                  />
                </div>
                <div className="col-md-2">
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>
                <div className="col-md-2">
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
                <div className="col-md-5 d-flex flex-wrap gap-2">
                  <button className="btn btn-primary"          onClick={handleSearch}>Search</button>
                  <button className="btn btn-info text-white"  onClick={setThisWeek}>This Week</button>
                  <button className="btn btn-warning"          onClick={setLastWeek}>Last Week</button>
                  <button className="btn btn-secondary"        onClick={handleReset}>Reset</button>
                </div>
              </div>

              {/* ── Summary ── */}
              {summary && (
                <div className="row mb-4">
                  <div className="col-md-4">
                    <div className="card bg-dark text-center p-3">
                      <small className="text-muted">Total Withdraw</small>
                      <h5 className="mb-0 text-danger">
                        ৳ {summary.totalAmount?.toFixed(2)}
                      </h5>
                    </div>
                  </div>
             
                </div>
              )}

              {/* ── Table ── */}
              <div className="table-responsive">
                <table className="table table-hover table-bordered">
                  <thead className="thead-light">
                    <tr>
                      <th>#</th>
                      <th>User</th>
                      <th>Method</th>
                      <th>Number</th>
                      <th>Amount (৳)</th>
                   
                      <th>Txn ID</th>
                      <th>Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length === 0 ? (
                      <tr>
                        <td colSpan="9" className="text-center text-muted py-4">
                          No records found.
                        </td>
                      </tr>
                    ) : (
                      data.map((el, i) => (
                        <tr key={el._id || i}>
                          <td>{(currentPage.current - 1) * limit + i + 1}</td>
                          <td>{el.user_id}</td>
                          <td className="text-capitalize">{el.selected_method}</td>
                          <td>{el.sender_number}</td>
                          <td>{el.withdraw_amount?.toFixed(2)}</td>
                       
                          <td><small>{el.trxid}</small></td>
                          <td><small>{formatDate(el.createdAt)}</small></td>
                          <td style={{ color: statusColor(el.status), fontWeight: 600 }}>
                            {el.status}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                <MyPaginate
                  breakLabel="..."
                  nextLabel="next >"
                  previousLabel="< prev"
                  pageCount={pageCount}
                  pageRangeDisplayed={5}
                  marginPagesDisplayed={2}
                  onPageChange={handlePageClick}
                  renderOnZeroPageCount={null}
                  forcePage={currentPage.current - 1}
                />
              </div>

            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default List;